(function ($) {
  threeStepFormatterV1 = {
    formatter: $('.three-step-formatter-v1')
  };

  Drupal.behaviors.threeStepFormatterV1 = {
    get: function (key) {
      return threeStepFormatterV1[key];
    },

    set: function (key, val) {
      threeStepFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // sticky header
        $('.three-step-sticky-header').appendTo($('#sticky_bar_content').html('')).attr('style', 'display:block');
      });
      $('.product-price').addClass('hidden');
      $('.btn-shopnow').attr('href', '/store_locator');
      $('.product-image a').removeAttr('href');
    }
  };
})(jQuery);
